import styled from 'styled-components';

interface IErrorUIProps {
  message?: string;
  onRetry: () => void;
}

const ErrorUI = ({ message = 'Failed to load data', onRetry }: IErrorUIProps) => {
  return (
    <ErrorContainer>
      <span className="error-message">{message}</span>
      <button className="retry-button" onClick={onRetry}>
        Retry
      </button>
    </ErrorContainer>
  );
};

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 1rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .error-message {
    font-size: 1.1rem;
    color: ${({ theme }) => theme.text};
  }

  .retry-button {
    padding: 0.5rem 1rem;
    border-radius: 4px;
    background-color: #007bff;
    color: white;
    border: none;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 500;
    transition: background-color 0.2s ease-in-out;

    &:hover {
      background-color: #0056b3;
    }

    &:focus {
      outline: 2px solid #0056b3;
      outline-offset: 2px;
    }
  }
`;

export default ErrorUI;
